import api from '@anm/api';
import { ApiError } from '@anm/api';
import { PasswordRecoveryParams } from '@anm/api/modules/auth';
import { compose, withHandlers, withState } from 'recompose';

import withAppMeta, { WithAppMetaProps } from '../../../../../HOCs/withAppMeta';
import vtConfig, { UrlNames } from '../../../../../config';
import { SubmitFormFields } from '../../../SubmitForm';

export interface RecoveryRequestHandler {
  setEmail: (email: string) => void;
  setError: (error: ApiError) => void;
  triggerFormSent: (isFormSent: boolean) => void;
  onRecoveryRequestSubmit: (fields: SubmitFormFields) => void;
}

const onRecoveryRequestSubmit = ({
  setEmail,
  setError,
  triggerFormSent,
  appMeta: { product }
}: RecoveryRequestHandler & WithAppMetaProps) => async ({ email }: SubmitFormFields) => {
  const productInLowerCase = product.toLocaleLowerCase() as UrlNames;
  const callback = `${vtConfig().urls[productInLowerCase]}recovery/#hash#`;

  const requestData: PasswordRecoveryParams = {
    email,
    product,
    callback
  };

  try {
    await api().auth.passwordRecoveryRequest(requestData);
    setEmail(email);
    triggerFormSent(true);
  } catch (err) {
    setError(err as ApiError);
  }
};

export default compose<RecoveryRequestHandler, {}>(
  withAppMeta,
  withState('email', 'setEmail', ''),
  withState('error', 'setError', null),
  withState('isFormSent', 'triggerFormSent', false),
  withHandlers<RecoveryRequestHandler, {}>({
    onRecoveryRequestSubmit
  })
);
